export default __webpack_public_path__ + "static/media/wedding-arch.0d91dd77.png";